import React from 'react';
import { ArrowRight } from 'lucide-react';
import { SHOP_URL } from '../mock';
import Reveal from './Reveal';

export default function CTA() {
  return (
    <section className="py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[32px] bg-gradient-to-br from-[#42563f] to-[#33422f] px-8 py-14 lg:px-16 lg:py-20 text-center">
            <div className="pointer-events-none absolute -top-16 -right-10 w-72 h-72 rounded-full bg-[#C4715A]/25 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-20 -left-10 w-72 h-72 rounded-full bg-[#E9D4CE]/15 blur-3xl" />
            <div className="relative">
              <h2 className="font-serif-display text-white text-[34px] sm:text-[46px] leading-tight max-w-2xl mx-auto">
                Send a little joy today
              </h2>
              <p className="mt-4 text-[17px] text-[#DCE3D6] max-w-xl mx-auto">
                Same-day delivery available on orders placed before 2 PM. Freshly arranged, beautifully delivered.
              </p>
              <a
                href={SHOP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group mt-8 inline-flex items-center gap-2 rounded-full bg-white text-[#3D5142] hover:bg-[#F1ECE3] text-[16px] font-medium px-8 py-4 transition-colors shadow-lg"
              >
                Order Flowers Now
                <ArrowRight className="w-4.5 h-4.5 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
